<template>
  <div class="page" v-if="can('admin.show')">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-account-tie</v-icon>
      إدارة المشرفين
      <back-button />
    </h2>
    <hr class="my-5 header-divider" />

    <!-- RECORD INFO DIALOG -->
    <record-info />
    
    <!-- PERMISSIONS FROM -->
    <permissions-form v-if="can('admin.store')" @update="fetchRecords({})" />

    <!-- UPDATE / NEW RECORD -->
    <div class="mb-3 mt-9 text-left">
      <v-btn
        v-if="can('admin.store')"
        color="primary"
        elevation="0"
        @click="SET_RECORD_FORM({}); SET_EDIT_MODE(false); SHOW_RECORD_FORM()"
      >
        إضافة مشرف
        <v-icon class="mr-2">mdi-plus</v-icon>
      </v-btn>
    </div>

    <!-- TABLE -->
    <v-data-table
      item-key="id"
      class="elevation-1"
      :loading="table.loading"
      :headers="table.headers"
      :items="records"
      loading-text="جاري تحميل البيانات"
      no-data-text="لا يوجد بيانات"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
    >
      <!-- CONTROLS -->
      <template v-slot:item.controls="{ item }">
        <v-btn
          v-if="can('admin.store')"
          small
          outlined
          color="green darken-2"
          class="mx-2"
          @click="SET_RECORD_FORM(item); SHOW_PERMISSIONS_FORM()"
        >
          الصلاحيات
        </v-btn>

        <v-btn
          small
          icon
          color="info"
          class="mx-2"
          @click="SET_CURRNET_RECORD(item); SHOW_RECORD_INFO()"
        >
          <v-icon>mdi-eye</v-icon>
        </v-btn>

        <v-btn
          v-if="can('admin.delete') && item.id != 1"
          small
          icon
          color="error"
          class="mx-2"
          @click="remove(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- PAGINATION -->
    <div class="text-center mt-7">
      <v-pagination
        total-visible="7"
        circle
        :value="parseInt(filters.page)"
        :length="totalPages"
        @input="$router.replace({ query: { ...$route.query, page: $event } })"
      ></v-pagination>
    </div>
  </div>
</template>


<script>
import RecordInfo from './RecordInfo';
import PermissionsForm from './PermissionsForm';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'admins',
  components: { RecordInfo, PermissionsForm },

  data: function () {
    return {
      table: {
        headers: [
          {
            value: 'id',
            text: 'رقم المشرف'
          },
          {
            value: 'name',
            text: 'الاسم'
          },
          {
            value: 'email',
            text: 'البريد الإلكتروني'
          },
          {
            value: 'created_at',
            text: 'تاريخ الإضافة'
          },
          {
            value: 'controls',
            text: 'اعدادات'
          }
        ],
        loading: false
      }
    }
  },


  computed: {
    ...mapState('admins', ['records', 'filters', 'totalPages']
    )
  },


  watch: {
    '$route': {
      async handler(route) {
        if (!route.query.page) {
          await this.$router.replace({ query: { ...route.query, page: 1 } });
          return;
        }

        this.SET_FILTERS(route.query);
        this.fetchRecords();
      },
      deep: true,
      immediate: true,
    }
  },


  methods: {
    ...mapMutations(
      'admins',
      [
        'SET_FILTERS',

        'SHOW_RECORD_FORM',
        'SET_EDIT_MODE',
        'SET_RECORD_FORM',

        'SHOW_RECORD_INFO',
        'SET_CURRNET_RECORD',

        'SHOW_PERMISSIONS_FORM'
      ]
    ),

    fetchRecords() {
      this.table.loading = true;

      this.$store.dispatch('admins/fetchRecords')
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب البيانات, يرجي التأكد من حالة الشبكة',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },

    async remove(selectedRecord) {
      const confirmMessageParams = [
        `حذف المشرف رقم ${selectedRecord.id}!`,
        `هل أنت متأكد من حذف المشرف '${selectedRecord.name}'؟`,
        { color: 'error' }
      ];

      if (!await this.$root.$confirm(...confirmMessageParams)) return;

      this.table.loading = true;

      this.$store.dispatch('admins/delete', { recordId: selectedRecord.id })
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم حذف المشرف بنجاح',
            color: 'success'
          });
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر حذف المشرف',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    }
  }
}
</script>
